module.exports = __webpack_public_path__ + "static/media/Predict-Logo-Login.c6b455c2.png";